module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAOCAMAAAAVBLyFAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAA5UExURUdwTBds9Rhr9Rds9Rdr9RZr9hNp9Rdr9Rds9Qxj8Rdr9Rdr9RZr9RZr9wBD/xZr9hNq9RVs9hhs9YokstgAAAASdFJOUwC1853DhB5PrwvW52xdBHU1VcdUUUAAAABnSURBVBjTZc9LDoAgEAPQ8mcERXv/w4pgDGA3kzzCUMApATXEkBiQ80KXoV1I0/qJzkQl065dNwG9O7q478XCzdcpljSqk0TqHT6R7ohvr+c81kuu9epVZXuKFwzULGAiiAkY6PftGzGIBnzdU4jEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/contact-check.png
// module id = 34MT
// module chunks = 0